// extracted by mini-css-extract-plugin
export default {"rule__absolute":"index_rule__absolute__WCCTW"};